/* INTEGY V443 — final LED zero-result route and DOM guard.
   Liquid is the primary owner. This runs last so older deferred scripts cannot restore
   rejected LED filter links, and stale bookmarked zero-result routes return safely to
   the nearest valid LED collection state. */
(function () {
  'use strict';

  var root = document.documentElement;
  var collection = 'led-lights';
  var allowed = {
    'bumper': true,
    'body': true,
    'body-mount': true,
    'led-light': true,
    'cooling-fan': true,
    '1-10': true,
    '1-8': true,
    '1-5': true,
    '1-18': true,
    'black': true,
    'blue': true,
    'red': true,
    'silver': true,
    'grey': true,
    'green': true,
    'orange': true,
    'purple': true,
    'gunmetal': true,
    'clearance': true
  };
  var observer;
  var timer = 0;

  function v626RootPath() {
    try {
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (rootPath) return rootPath.charAt(rootPath.length - 1) === '/' ? rootPath : rootPath + '/';
    } catch (error) {}
    return '/';
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;|&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function pathData(pathname) {
    var parts = String(pathname || '').split('/').filter(Boolean);
    var index = parts.indexOf('collections');
    return {
      base: index >= 0 && parts[index + 1] ? handleize(decodeURIComponent(parts[index + 1])) : '',
      tags: index >= 0 && parts[index + 2]
        ? decodeURIComponent(parts.slice(index + 2).join('/')).split('+').map(handleize).filter(Boolean)
        : []
    };
  }

  function currentIsLed() {
    return pathData(location.pathname).base === collection;
  }

  function sanitizeRoute() {
    var data = pathData(location.pathname);
    if (data.base !== collection || !data.tags.length) return false;
    var valid = data.tags.filter(function (tag) { return allowed[tag]; });
    if (valid.length === data.tags.length) return false;
    var target = v626RootPath() + 'collections/' + collection + (valid.length ? '/' + valid.join('+') : '') + (location.search || '') + (location.hash || '');
    location.replace(target);
    return true;
  }

  function tagFromAnchor(anchor) {
    var explicit = handleize(anchor && anchor.getAttribute && anchor.getAttribute('data-tag-handle'));
    if (explicit) return explicit;
    if (!anchor || !anchor.href) return '';
    try {
      var data = pathData(new URL(anchor.href, location.origin).pathname);
      if (data.base !== collection || data.tags.length !== 1) return '';
      return data.tags[0];
    } catch (error) {
      return '';
    }
  }

  function reject(node) {
    if (!node || node.getAttribute('data-integy-v443-zero-result') === 'true') return;
    node.setAttribute('data-integy-v443-zero-result', 'true');
    node.setAttribute('aria-hidden', 'true');
    node.hidden = true;
    var controls = node.matches && node.matches('a,button,input,option') ? [node] : (node.querySelectorAll ? node.querySelectorAll('a,button,input,option') : []);
    Array.prototype.forEach.call(controls, function (control) {
      control.setAttribute('aria-disabled', 'true');
      if (control.matches('a,button')) control.tabIndex = -1;
    });
  }

  function scan(scope) {
    if (!currentIsLed()) return;
    var host = scope && scope.querySelectorAll ? scope : document;
    var rows = host.querySelectorAll('[data-tag-handle],.integy-v353-static-filter-row,a[href*="/collections/led-lights/"]');
    Array.prototype.forEach.call(rows, function (candidate) {
      var anchor = candidate.matches && candidate.matches('a') ? candidate : (candidate.querySelector && candidate.querySelector('a'));
      var tag = tagFromAnchor(anchor || candidate);
      if (!tag || allowed[tag]) return;
      var row = candidate.closest && candidate.closest('.integy-v353-static-filter-row,[data-integy-v200-filter-row],.integy-v27-filter-chip,li');
      reject(row || candidate);
    });
    root.classList.add('integy-v443-led-zero-guard-ready');
  }

  function schedule(scope) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { scan(scope || document); }, 40);
  }

  document.addEventListener('click', function (event) {
    if (!currentIsLed()) return;
    var anchor = event.target && event.target.closest ? event.target.closest('a[href],button[data-tag-handle]') : null;
    if (!anchor) return;
    var tag = tagFromAnchor(anchor);
    if (!tag || allowed[tag]) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }, true);

  function boot() {
    if (sanitizeRoute()) return;
    scan(document);
    if (window.MutationObserver) {
      observer = new MutationObserver(function (mutations) {
        if (mutations.some(function (mutation) { return mutation.addedNodes && mutation.addedNodes.length; })) schedule(document);
      });
      observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
  }

  document.addEventListener('shopify:section:load', function (event) { schedule(event.target || document); });
  window.addEventListener('pageshow', function () { schedule(document); });
  window.IntegyV443LedZeroGuard = { scan: scan, allowed: allowed };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
